import React, { Component, ReactElement, ReactNode } from "react";
import style from "./list.module.sass";
import { Icon, Spin, Table } from "antd";
import { ReactComponent as TableEdit } from '../../../../assets/svg/editIcon.svg'
import { ReactComponent as Delete } from '../../../../assets/svg/delete.svg'
import Solo from "./Solo";
import moment from 'moment';
import { connect } from "react-redux";
import { deleteForm } from "../../../../stateManager/store/forms/action";
import { Http } from "../../../../helpers/axois";
import { ReactComponent as BpmIllustration } from '../../../../assets/svg/bpm_illustration.svg'
import NoData from '../../NoData'
import { Button, Modal } from '../../../../helpers/commonUi'
import { IsoloList } from './Isolo'
import { selectedSolo, selectedJourney } from '../../../../stateManager/store/solo/action';
import { pushToast } from '../../../../stateManager/store/toast/actions'
// import moment from 'moment'
import publicIcon from "../../../../assets/svg/solo/public_col_ico.svg"
import privateIcon from "../../../../assets/svg/solo/private_col_ico.svg"
// {moment(data.updated_at).format("DD-MM-YYYY")}
import { ReactComponent as WarningIcon } from '../../../../assets/svg/warningIcon.svg'
import { AppState } from "../../../../stateManager/store";
import { setStepIndex } from "../../../../stateManager/store/onboarding/action";
import SearchBar, { highlightMatch } from "../../../../helpers/SearchBar";
import _ from "lodash";

interface State {
  visible: boolean;
  editInitialData?: {};
  editSoloData?: {};
  formsList?: any[];
  editable: boolean;
  editvisible?: boolean;
  editSolo: boolean;
  SoloLoading: boolean;
  soloList: IsoloList[];
  [key: string]: any;
  deleteVisible: boolean;
  deleteData: any;
  editType: string;
  filteredData: any[]
  searchValue: string;
  searchRef: React.RefObject<{ clearSearch: () => void }>
}

interface Props {
  match?: any;
  app?: any;
  history?: any;
  selectedSolo?: any;
  selectedJourney?: any;
  deleteForm: (data: any) => void;
  appVersion?: { currentVersion: boolean, versionId: string };
  currentBranch?: any;
  pushToast: (data: any) => void;
  orgPermissions: any;
  appPermissions: any;
  setStepIndex: (data: any) => void;
  stepIndex: number;
  onboardingInfo: any;
  guideVisible: boolean;
}

class SoloList extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
      editInitialData: {},
      editable: false,
      editvisible: false,
      SoloLoading: false,
      deleteVisible: false,
      soloList: [],
      deleteData: {},
      editSoloData: {},
      editSolo: false,
      editType: "",
      filteredData: [],
      searchValue: "",
      searchRef: React.createRef()
    };
  }

  componentDidMount() {
    this.getSolo(this.props)
  }

  componentWillReceiveProps(prevProps: Props) {
    if (!_.isEqual(prevProps.appVersion, this.props.appVersion)) {
      this.getSolo(this.props)
    }
  }


  getSolo(props: Props) {
    this.state.searchRef.current?.clearSearch()
    this.setState({ SoloLoading: true })
    const appId = this.props.match.params.appId
    const versionId = props.appVersion && props.appVersion.versionId;
    if (versionId) {
      Http.get(`/apps/${appId}/solo-flows?versionId=${versionId}`).subscribe((formRes: any) => {
        this.setState({
          soloList: formRes.flows,
          filteredData: formRes.flows,
          SoloLoading: false
        })
      }, (err: any) => {
        this.setState({
          SoloLoading: false,
          filteredData: [],
          soloList: []
        })
      });
    }
  }


  deleteSolo(id: string) {
    const appId = this.props.match.params.appId;
    const versionId = this.props.appVersion && this.props.appVersion.versionId;
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[appId] && this.props.currentBranch[appId].branchId
    Http.delete(`apps/${appId}/solo-flows/${id}?versionId=${versionId}&branchId=${currentBranchId}`).subscribe((res) => {
      this.props.pushToast(
        { type: 'success', message: 'Journey deleted successfully' }
      )
      this.getSolo(this.props);
    }, (err) => {
      this.props.pushToast(
        { type: 'error', message: (err && err.message) ? err.message : 'Journey deletion failed' }
      )
    })
  }

  render() {
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.match.params.appId] && this.props.currentBranch[this.props.match.params.appId].branchId
    const currentVersion = this.props.appVersion && this.props.appVersion.currentVersion;
    const canEditSolo = currentVersion && (this.props.orgPermissions.includes('bpmn.Edit') || this.props.appPermissions.includes('bpmn.Edit'))
    const canCreateSolo = currentVersion && (this.props.orgPermissions.includes('bpmn.Create') || this.props.appPermissions.includes('bpmn.Create'))
    const canDeleteSolo = currentVersion && (this.props.orgPermissions.includes('bpmn.Delete') || this.props.appPermissions.includes('bpmn.Delete'))
    const canViewSolo = this.props.orgPermissions.includes('bpmn.View') || this.props.appPermissions.includes('bpmn.View')

    let soloColumns: any = [
      {
        title: "Display Name",
        dataIndex: "displayName",
        key: "displayName",
        render: (text: any, record: any) => {
          let formattedValue = highlightMatch(text || record?.name, this.state.searchValue)
          return(
            <>
              {record.type === "public" ? <img style={{ marginBottom: "2px" }} alt="publicIcon" src={publicIcon} /> : <img style={{ marginBottom: "2px" }} alt="privateIcon" src={privateIcon} />} {formattedValue || record.name}
            </>
          )
        }
      },
      {
        title: "Name(Identifier)",
        dataIndex: "name",
        key: "name",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Created By",
        dataIndex: "createdBy",
        key: "createdBy",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Created At",
        dataIndex: "createdAt",
        key: "createdAt",
        render: (text: string) => {
          let formattedValue: any  = text ?  moment(text).local().format("DD-MM-YYYY hh:mm a") : "-"
          formattedValue = highlightMatch(formattedValue, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Updated At",
        key: "updatedAt",
        dataIndex: "updatedAt",
        render: (text: string) => {
          let formattedValue: any  = text ?  moment(text).local().format("DD-MM-YYYY hh:mm a") : "-"
          formattedValue = highlightMatch(formattedValue, this.state.searchValue)
          return formattedValue
        }
      }
    ];

    if (currentVersion) {
      soloColumns.push(
        {
          title: "Action",
          key: "action",
          render: (text: any, record: any) => (
            <span>
              <span data-test-id="action_edit"
                className="action-icon edit-icon"
                title="Edit"
                onClick={e => {
                  e.stopPropagation();
                  if (this.props.guideVisible) {
                    return;
                  }
                  if (canEditSolo) {
                    this.setState({
                      editvisible: true,
                      editType: "solo",
                      editable: true,
                      editSoloData: record,
                    });
                    this.setState({
                      [record.bpmnid]: false
                    });
                  } else {
                    this.props.pushToast({
                      type: 'error',
                      message: 'You are not authorized to edit this solo'
                    })
                  }
                }}
              >
                <TableEdit height='15px' width='15px' />
              </span>
              <span
                data-test-id="action_delete"
                className="action-icon delete-icon"
                title="Delete"
                onClick={e => {
                  e.stopPropagation();
                  if (this.props.guideVisible) {
                    return;
                  }
                  if (canDeleteSolo) {
                    this.setState({
                      deleteData: record,
                      editType: "solo",
                      deleteVisible: true
                    });
                  } else {
                    this.props.pushToast({
                      type: 'error',
                      message: 'You are not authorized to delete this Journey'
                    })
                  }
                }}
              >
                <Delete />
              </span>
            </span>
          )
        }
      )
    }

    const appId = this.props.match.params.appId
    let { SoloLoading } = this.state;
    let { soloList } = this.state;
    const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
    //const isRenderSolo = window.location.origin.includes("localhost") || window.location.origin.includes("testing");
    return (
      <>
        {canViewSolo ?
          <div className='viewWrapper'>
            {
              !SoloLoading ?
                (
                  <React.Fragment>
                    {
                      (soloList.length > 0 && (currentBranchId !== null)) ?
                        (
                          <div className={"row " + style.data}>
                            <div className={style.header} >
                            <div className={style.first}>
                                <h4>SOLO</h4>
                                <h5>View, edit or create Solo diagrams</h5>
                              </div>
                              <div className={"flex " + style.first}>
                                <SearchBar
                                  ref={this.state.searchRef}
                                  data={soloList}
                                  columns={soloColumns}
                                  onFilter={(filteredData ) => {
                                    this.setState({
                                      filteredData: filteredData,
                                    })
                                  }}
                                  onSearchTermChange={ (searchValue: string)=>{ this.setState({searchValue: searchValue}) } }
                                />
                                {canCreateSolo &&
                                  <Button 
                                    className={'tour_journey_creation_initial'} 
                                    dataTestId="create_journey" 
                                    size="small" 
                                    onClick={() => {
                                       this.setState({ visible: true }) 
                                       if (this.props.guideVisible) {
                                         this.props.setStepIndex(this.props.stepIndex + 1)
                                       }
                                    }}>
                                    CREATE JOURNEY
                                  </Button>
                                }
                              </div>
                            </div>
                            <div className={style.content}>
                              <Table
                                pagination={false}
                                scroll={{ y: 'calc(100vh - 240px)' }}
                                columns={soloColumns}
                                onRow={(record: any, rowIndex: any) => {
                                  return {
                                    'data-test-id': 'solo_table_row' + record.key,
                                    className: record.id === this.props.onboardingInfo.flowId ? "tour_journey_row_selection":"",
                                    onClick: () => {
                                      this.props.selectedSolo(record);
                                      this.props.history.push(
                                        this.props.match.url +
                                        "/" +
                                        record.id +
                                        "/create"
                                      );
                                      if (record.id === this.props.onboardingInfo.flowId && this.props.guideVisible) {
                                        this.props.setStepIndex(this.props.stepIndex + 1);
                                      }
                                    },
                                  };
                                }}
                                data-test-id="solo_table"
                                className={"override-table-container"}
                                dataSource={this.state.filteredData.map((res, key) => {
                                  return { ...res, key: key };
                                })}
                              />
                            </div>
                          </div>
                        )
                        :
                        (
                          <NoData
                            svg={BpmIllustration}
                            header='Create Journey'
                            content='Create Journey diagram with graphical elements'
                            buttonCallback={(()=> {
                              if (canCreateSolo) {
                                this.setState({ visible: true });
                                this.props.guideVisible && this.props.setStepIndex(this.props.stepIndex + 1)
                              } else {
                                this.props.pushToast({
                                  type: 'error',
                                  message: 'You are not authorized to create Journeys'
                                })
                              }
                              
                            })}
                            buttonClassName = "tour_journey_creation_initial"
                          />
                        )
                    }
                  </React.Fragment>
                )
                :
                (
                  <div className={style.loadingSpinner}>
                    <Spin indicator={antIcon} style={{ color: '#15808C' }} />
                  </div>
                )
            }
            <FormModal
              data-test-id="form_modal"
              visible={this.state.visible}
              getSolo={() => this.getSolo(this.props)}
              appId={appId}
              editType={this.state.editType}
              appVersion={this.props.appVersion}
              setvisible={status => this.setState({ visible: status })}
            ></FormModal>
            {this.state.editvisible && (
              <FormModal
                data-test-id="edit_form_modal"
                getSolo={() => this.getSolo(this.props)}
                visible={this.state.editable}
                editInitialData={this.state.editInitialData}
                editSoloData={this.state.editSoloData}
                appId={appId}
                appVersion={this.props.appVersion}
                editType={this.state.editType}
                setvisible={status => {
                  this.setState({ editable: status, editInitialData: {} });
                  setTimeout(() => {
                    this.setState({ editvisible: false });
                  }, 400);
                }}
                editable={this.state.editable}
              ></FormModal>
            )}
            {<Modal
              dataTestId="delete_solo"
              id="deleteBpmn"
              unmountOnCancel={true}
              visible={this.state.deleteVisible}
              title="DELETE JOURNEY"
              onCancel={() => {
                this.setState({
                  deleteVisible: false,
                  deleteData: {}
                })
              }}
              deleteOptions={{
                type: "Bpmn",
                validateString: this.state.deleteData.name
              }}
              footer={{
                enable: true,
                okText: 'DELETE',
                cancelText: 'CANCEL',
                onOk: () => {
                  this.deleteSolo(this.state.deleteData.id)
                  this.setState({
                    deleteVisible: false,
                    searchValue: "",
                    filteredData: this?.state?.formsList || []
                  })
                }
              }}
            />}
          </div>
          :
          <div className="viewWrapper">
            <NoData
              svg={WarningIcon}
              header='Not Authorized'
              content='Please request owner of this organization to provide access'
              noButton={true}
            />
          </div>}
      </>
    );
  }
}
interface FormmodelProps {
  appVersion?: { currentVersion: boolean, versionId: string };
  visible: boolean;
  getSolo: () => void;
  setvisible: (status: boolean) => void;
  appId: any;
  editInitialData?: {};
  editSoloData?: {};
  editable?: boolean;
  editType: string;
}
let onSubmit: any;
const FormModal = ({
  visible,
  getSolo,
  setvisible,
  editType,
  appId,
  appVersion,
  editInitialData,
  editSoloData,
  editable,
}: FormmodelProps) => {
  return (
    <Modal
      id="createEditBpmn"
      dataTestId="created_edit_solo"
      title={editInitialData ? 'EDIT JOURNEY' : 'CREATE JOURNEY'}
      visible={visible}
      className="app_cre_mdl"
      onCancel={() => {
        setvisible(false);
      }}
      unmountOnCancel={true}
      footer={{
        enable: false,
      }}
    >
      <Solo
        appVersion={appVersion}
        setvisible={setvisible}
        appId={appId}
        getSolo={getSolo}
        editType={editType}
        editInitialData={editInitialData}
        editSoloData={editSoloData}
        onSubmit={(submit: any) => {
          onSubmit = submit;
          submit(setvisible);
        }}
        onCancel={() => {
          setvisible(false);
        }}
        editable={editable}
        okButtonText={ editable ? "SAVE" : "CREATE"}
        cancelText={"CANCEL"}
      ></Solo>
    </Modal>
  );
};

const mapStateToProps = (state: AppState, props: Props) => {
  const params: any = props.match.params;
  return {
    appVersion: state.apps.appVersion[params['appId']],
    currentBranch: state.apps.appBranch,
    orgPermissions: state.org.orgPermissions,
    appPermissions: state.apps.selectedApp.permissions,
    stepIndex: state.onboarding.info.stepIndex,
    onboardingInfo: state.onboarding.info,
    guideVisible: state.onboarding.guideVisible
  }
};

export default connect(
  mapStateToProps,
  { deleteForm, pushToast, selectedSolo, selectedJourney, setStepIndex }
)(SoloList);
